import { motion } from "framer-motion"
import { CheckCircle } from "lucide-react"

const SuccessPopup = ({ title, message, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center p-4">
        <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className="bg-white p-6 rounded-2xl shadow-xl max-w-sm w-full text-center"
        >
            <CheckCircle className="mx-auto text-green-500 w-12 h-12 mb-3" />

            <h2 className="text-xl font-semibold text-gray-800 mb-2">
                {title || "Upload Successful"}
            </h2>

            <p className="text-gray-500 text-sm mb-6">
                {message || "Your document has been uploaded successfully."}
            </p>

            <button
                onClick={onClose}
                className="bg-blue-600 hover:bg-blue-700 transition text-white px-5 py-2.5 rounded-lg font-medium shadow-md"
            >
                Close
            </button>
        </motion.div>
    </div>
)

export default SuccessPopup
